<template>
  <FaIcon :icon="['fas', 'gear']" />
</template>
